import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Input,
  Table,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIupdateFilesOrder } from '../../api/Collections';
import {
  swapFiles as swapFilesAction,
  setSelectedFiles,
} from '../../actions/Files';

import FilesListItem from './ListItem';

import { addFlashMessage } from '../../helpers/FlashMessages';
import { getSetting } from '../../helpers/Settings';
import withDragAndDropContext from '../../helpers/withDragAndDropContext';
import withFileSelection from '../../hoc/withFileSelection';

class FilesList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      movedMenuItem: null,
    };

    this.moveFile = this.moveFile.bind(this);
    this.saveFiles = this.saveFiles.bind(this);
  }

  moveFile(dragIndex, hoverIndex) {
    const { swapFiles } = this.props;
    swapFiles(dragIndex, hoverIndex);
  }

  saveFiles(dragIndex) {
    const {
      intl,
      collection,
      files,
    } = this.props;
    if (!collection) {
      return;
    }

    this.setState({ movedMenuItem: dragIndex });
    const cfiles = files.map(f => (f.uuid));
    APIupdateFilesOrder(collection.uuid, cfiles).finally(() => {
      this.setState({ movedMenuItem: null });
    }).catch(() => {
      addFlashMessage({
        type: 'danger',
        text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
      });
    });
  }

  isSelectAllChecked() {
    const {
      files,
      selectedFiles,
    } = this.props;

    return files.length > 0 && files.length === selectedFiles.length;
  }

  selectAllFiles() {
    const {
      files,
      selectFiles,
    } = this.props;
    selectFiles(files);
  }

  unselectAllFiles() {
    const { selectFiles } = this.props;
    selectFiles([]);
  }

  render() {
    const {
      intl,
      files,
      className,
      reorderingMode,
      selectedFiles,
      filesLoading,
      handleMoveSelectedItems,
    } = this.props;
    const { movedMenuItem } = this.state;
    const isSelectAllChecked = this.isSelectAllChecked();

    return (
      <div className="files-list content-wrapper">
        {!(filesLoading && files.length === 0) && (
          <div className="table-wrapper">
            <Table
              className={classnames(
                'files-list',
                className,
                { reordering: reorderingMode },
              )}
              responsive
            >
              <thead>
                <tr>
                  <th className="selector">
                    <Input
                      type="checkbox"
                      className="input-check check-s form-check-input"
                      checked={isSelectAllChecked}
                      onChange={() => {
                        if (isSelectAllChecked) {
                          this.unselectAllFiles();
                        } else {
                          this.selectAllFiles();
                        }
                      }}
                    />
                  </th>
                  <th>
                    {' '}
                  </th>
                  <th>
                    {intl.formatMessage({ defaultMessage: 'File Name' })}
                  </th>
                  <th>
                    {intl.formatMessage({ defaultMessage: 'Owner' })}
                  </th>
                  <th>
                    {intl.formatMessage({ defaultMessage: 'Created' })}
                  </th>
                  <th>
                    {getSetting('cs1') ? intl.formatMessage({ defaultMessage: 'Date' }) :
                      intl.formatMessage({ defaultMessage: 'Uploaded / Updated' })}
                  </th>
                  <th>
                    {' '}
                  </th>
                </tr>
              </thead>
              <tbody>
                {files.map(f => (
                  <FilesListItem
                    id={f.uuid}
                    index={f.uuid}
                    key={f.uuid}
                    file={f}
                    moveFile={this.moveFile}
                    saveFiles={this.saveFiles}
                    handleMoveSelectedItems={handleMoveSelectedItems}
                    canDrag={true}
                    isMoved={movedMenuItem === f.uuid}
                    isSelected={!!selectedFiles.find(sf => (sf.uuid === f.uuid))}
                    {...this.props}
                  />
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collection: state.Collections.collection,
  reorderingMode: state.Files.reorderingMode,
  selectedFiles: state.Files.selectedFiles,
  filesLoading: state.Files.loading,
});

const mapDispatchToProps = dispatch => ({
  swapFiles: (firstItem, secondItem) => {
    dispatch(swapFilesAction(firstItem, secondItem));
  },
  selectFiles: (files) => {
    dispatch(setSelectedFiles(files));
  },
});

FilesList.propTypes = {
  intl: PropTypes.object.isRequired,
  collection: PropTypes.object,
  reorderingMode: PropTypes.bool.isRequired,
  swapFiles: PropTypes.func.isRequired,
  selectFiles: PropTypes.func.isRequired,
  handleMoveSelectedItems: PropTypes.func.isRequired,
  files: PropTypes.array.isRequired,
  className: PropTypes.string,
  selectedFiles: PropTypes.array.isRequired,
  filesLoading: PropTypes.bool.isRequired,
};

FilesList.defaultProps = {
  collection: null,
  className: '',
};

export default withDragAndDropContext(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(withFileSelection(FilesList))),
);
